import { CheckoutRequest } from "@/pages/agentic/checkout";
import { ErrorMessage, SDKError } from "./error";

const walletUrl = process.env.REACT_APP_WALLET_URL || "";

interface CheckoutResponse {
  id: string
}
export class AgenticCheckoutService {


  static async initCheckout(id: string): Promise<CheckoutRequest> {
    try {
      console.log("get checkout ", id);
      const reg_url = walletUrl + `/agentic/checkout/init/${id}`;
      const response = await fetch(reg_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      if (response.ok) {
        const res: CheckoutRequest = await response.json();
        return Promise.resolve(res);
      } else {
        const e: ErrorMessage = await response.json();
        return Promise.reject(new SDKError(e.message));
      }
    } catch (error) {
      console.log("checkout error: ", error);
      return Promise.reject(new SDKError("fail checkout"));
    }
  }

  static async updateCheckout(id: string): Promise<CheckoutRequest> {
    try {
      console.log("update checkout ", id);
      const reg_url = walletUrl + `/agentic/checkout/update/${id}`;
      const response = await fetch(reg_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      if (response.ok) {
        const res: CheckoutRequest = await response.json();
        return Promise.resolve(res);
      } else {
        const e: ErrorMessage = await response.json();
        return Promise.reject(new SDKError(e.message));
      }
    } catch (error) {
      console.log("checkout error: ", error);
      return Promise.reject(new SDKError("fail checkout"));
    }
  }

  static async completeCheckout(id: string): Promise<CheckoutRequest> {
    try {
      console.log("complete checkout ", id);
      const reg_url = walletUrl + `/agentic/checkout/complete/${id}`;
      const response = await fetch(reg_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      if (response.ok) {
        const res: CheckoutRequest = await response.json();
        return Promise.resolve(res);
      } else {
        const e: ErrorMessage = await response.json();
        return Promise.reject(new SDKError(e.message));
      }
    } catch (error) {
      console.log("checkout error: ", error);
      return Promise.reject(new SDKError("fail checkout"));
    }
  }

  static async cancelCheckout(id: string): Promise<boolean> {
    try {
      console.log("complete checkout ", id);
      const reg_url = walletUrl + `/agentic/checkout/cancel/${id}`;
      const response = await fetch(reg_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      if (response.ok) {
        await response.json();
        return Promise.resolve(true);
      } else {
        const e: ErrorMessage = await response.json();
        return Promise.reject(new SDKError(e.message));
      }
    } catch (error) {
      console.log("checkout error: ", error);
      return Promise.reject(new SDKError("fail checkout"));
    }
  }

  static async checkout(r: CheckoutRequest): Promise<string> {
    try {

      const reg_url = walletUrl + "/checkout/cache";
      const response = await fetch(reg_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(r)
      })
      console.log("get response")
      if (response.ok) {
        const resp: CheckoutResponse = await response.json();
        return Promise.resolve(resp.id);
      } else {
        const e: ErrorMessage = await response.json();
        return Promise.reject(new SDKError(e.message));
      }
    } catch (error) {
      console.log("register error: ", error);
      return Promise.reject(new SDKError("fail register"));
    }
  }
}